import { getOrganizationId } from "../../organizations/state/organizationId";
import { getOrganizationType } from "../../organizations/state/organizationType";

export function getOrganizationPath(path, adminFallback = false) {
	if (!path.startsWith("/")) {
		return path;
	}

	const organizationType = getOrganizationType();
	const organizationId = getOrganizationId();

	if (["publisher", "producer", "narrator"].includes(organizationType)) {
		return `/${organizationType}/${organizationId}${path}`;
	}

	if (adminFallback || organizationType === "admin") {
		return `/admin${path}`;
	}

	throw new Error("Invalid organization type");
}
